import { render, staticRenderFns } from "./urbanBigData.vue?vue&type=template&id=49393735&"
import script from "./urbanBigData.vue?vue&type=script&lang=js&"
export * from "./urbanBigData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports